import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  setItem<T>(key: string, value: T): void {
    if (value == null) {
      return;
    }

    localStorage.setItem(key, JSON.stringify(value));
  }

  getItem<T>(key: string): T | null {
    const data = localStorage.getItem(key);
    if (!data) {
      return null;
    }

    return JSON.parse(data) as T;
  }

  removeItem(key: string): void {
    localStorage.removeItem(key);
  }

  updateItem<T>(
    key: string,
    update: Partial<T> | string | number | boolean
  ): void {
    if (update == null) {
      return;
    }
    if (typeof update === 'object') {
      const existingObj = this.getItem<T>(key) ?? ({} as T);
      const newObj = { ...existingObj, ...update };
      this.setItem(key, JSON.stringify(newObj));
    } else {
      this.setItem(key, JSON.stringify(update));
    }
  }
}
